import React from 'react';

const ResultPage = () => {
    return (
        <div>
            <h2>Results</h2>
            {/* Add content from result.php here */}
        </div>
    );
};

export default ResultPage;
